// Global daily-limit handling shared across upload and chat surfaces (ORA-395).
//
// These "global" caps apply to every user — including paid subscribers — and
// are distinct from the Free-tier caps (DAILY_UPLOAD_LIMIT /
// DAILY_CHAT_RESPONSE_LIMIT), which keep their existing "upgrade for unlimited"
// UX. When a global cap is hit the backend returns one of these codes and we
// show a support-oriented toast instead of the upgrade modal.

export const DAILY_DOC_LIMIT_GLOBAL_CODE = 'DAILY_DOC_LIMIT_GLOBAL';
export const DAILY_MESSAGE_LIMIT_GLOBAL_CODE = 'DAILY_MESSAGE_LIMIT_GLOBAL';
/** System-wide AI spend backstop (ORA-429). */
export const AI_BUDGET_EXCEEDED_CODE = 'AI_BUDGET_EXCEEDED';

/** Structured `MappingJob.errorCode` for a document rejected over the page cap. */
export const PAGE_LIMIT_EXCEEDED_CODE = 'PAGE_LIMIT_EXCEEDED';

/** Toast copy shown when a user hits a global daily cap. */
export const DAILY_GLOBAL_LIMIT_MESSAGE =
  'Daily Limit Reached - Please reach out to support to increase your limit.';
